/*
 * @Description: 
 * @Author: shenkaiyao
 * @Date: 2020-09-21 14:00:52
 * @LastEditors: 
 * @LastEditTime: 2020-09-21 14:04:05
 */
import Popconfirm from './popconfirm';

export default Popconfirm